import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

const ItemNumberCell = (params: ICellRendererParams) => {
  // Group rows render the group key (item description) as-is.
  if (params.node.group) {
    return <span>{params.value ?? params.node.key}</span>;
  }
  if (!params.data) return null;
  const shipWindowCount: number = params.data.shipWindowCount ?? 0;

  return (
    <span className="px-item-number-cell">
      <span>{params.value}</span>
      {/* The item number is blank on the repeated rows of a grouped item, the
          badge belongs to the row that actually renders it. */}
      {!!params.value && shipWindowCount > 1 && (
        <span className="px-ship-windows-badge">
          <span className="px-ship-windows-divider">&#8214;</span>
          {`${shipWindowCount} Ship Windows`}
        </span>
      )}
    </span>
  );
};

export default ItemNumberCell;
